import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Subject } from "rxjs/Subject";
import 'rxjs/add/operator/takeUntil';
import { Subscription } from 'rxjs/Subscription';
import { fuseAnimations } from '../../../../../../../../core/animations';

/** Query file */
import { WCSubCategoriesQueryService } from '../../../../../queryFiles/index';

import { ToastComponent } from '../../../../../common/toast.component';

import { toastMsg } from '../../../../../utils/index';

@Component({
    selector: 'add-sub-category',
    templateUrl: './addSubCategory.component.html',
    styleUrls: ['./addSubCategory.component.scss'],
    animations: fuseAnimations,
})

export class AddSubCategoryPopupComponent {

    toastMsg = toastMsg;

    subCategory: string;
    subCategorySubscription = new Subject<void>();
    lastSubCateId: number;

    getLastSubCateIdSubscription: Subscription;
    saveSubCategorySubscription: Subscription;

    constructor(
        public dialogRef: MatDialogRef<AddSubCategoryPopupComponent>,
        //Read data from parent component
        @Inject(MAT_DIALOG_DATA) private parentData: any,
        /** Query file */
        public wCSubCategoriesQueryService: WCSubCategoriesQueryService,

        public toastComponent: ToastComponent
    ) {
        this.getLastSubCateId();
    }

    ngOnDestroy() {
        this.saveSubCategorySubscription && this.saveSubCategorySubscription.unsubscribe();
        this.getLastSubCateIdSubscription && this.getLastSubCateIdSubscription.unsubscribe();
    }

    getLastSubCateId() {

        this.getLastSubCateIdSubscription = this.wCSubCategoriesQueryService.GET_LAST_WC_SUB_CATEGORY_ID()
            .valueChanges
            .subscribe((response: any) => {

                if (response.data.allWcsubcategories.edges.length > 0) {
                    this.lastSubCateId = response.data.allWcsubcategories.edges[0].node.subid
                } else {
                    this.lastSubCateId = 0;
                }

            })

    }

    saveSubCategory() {

        var params = {
            subCategory: this.subCategory,
            categoryId: this.parentData.mainCategoryId,
            subId: this.lastSubCateId + 1
        }
        if (this.subCategory) {

            this.saveSubCategorySubscription = this.wCSubCategoriesQueryService
                .CREATE_WC_SUB_CATEGORIES(params)
                .takeUntil(this.subCategorySubscription)
                .subscribe(() => {

                    this.subCategorySubscription.complete(); /**Complete subscription */
                }, () => {
                    this.dialogRef.close(['failed', '']);

                }, () => {
                    this.dialogRef.close(['save', params]); /**Complete subscription */

                })

        } else {
            this.toastComponent.showToast(toastMsg.warningNoSubCate);
        }



    }

    cancel() {
        this.dialogRef.close(['cancel', ''])
    }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/solutionForm/walk-call/walk-call-body/add-subcategory/addSubCategory.component.ts